type TEXT_FORMAT = string | number

export function ft_replaceSpecialChar(text: TEXT_FORMAT, lower = false, removeSpace = false) {
	if (typeof(text) !== 'string')
		text = `${text}`;

	let result = text
	.replace(/à/g, 'a')
	.replace(/á/g, 'a')
	.replace(/â/g, 'a')
	.replace(/ä/g, 'a')
	.replace(/æ/g, 'a')
	.replace(/ã/g, 'a')
	.replace(/ā/g, 'a')

	.replace(/ç/g, 'c')
	.replace(/ć/g, 'c')
	.replace(/č/g, 'c')

	.replace(/é/g, 'e')
	.replace(/è/g, 'e')
	.replace(/ê/g, 'e')
	.replace(/ë/g, 'e')
	.replace(/ē/g, 'e')
	.replace(/ė/g, 'e')
	.replace(/ę/g, 'e')

	.replace(/î/g, 'i')
	.replace(/ï/g, 'i')
	.replace(/í/g, 'i')
	.replace(/ī/g, 'i')
	.replace(/į/g, 'i')
	.replace(/ì/g, 'i')

	.replace(/ł/g, 'l')

	.replace(/ñ/g, 'n')
	.replace(/ń/g, 'n')

	.replace(/ô/g, 'o')
	.replace(/ö/g, 'o')
	.replace(/ò/g, 'o')
	.replace(/ó/g, 'o')
	.replace(/œ/g, 'o')
	.replace(/ø/g, 'o')
	.replace(/ō/g, 'o')
	.replace(/õ/g, 'o')

	.replace(/ß/g, 's')
	.replace(/ś/g, 's')
	.replace(/š/g, 's')

	.replace(/û/g, 'u')
	.replace(/ü/g, 'u')
	.replace(/ù/g, 'u')
	.replace(/ú/g, 'u')
	.replace(/ū/g, 'u')

	.replace(/ÿ/g, 'y')

	.replace(/ž/g, 'z')
	.replace(/ź/g, 'z')
	.replace(/ż/g, 'z')

	.replace(/%22/g, '"');

	if (removeSpace)
		result = result.replace(/ /g, '');

	if (lower)
		result = result.toLowerCase();

	return result;
}

export function ft_search(text: TEXT_FORMAT | TEXT_FORMAT[], search: TEXT_FORMAT, lower = false, removeSpace = false) {
	if (!search)
		return false;

	const checkSearch = (actualText: TEXT_FORMAT) => {
		const finalText = ft_replaceSpecialChar(actualText, lower, removeSpace);
		const finalSearch = ft_replaceSpecialChar(search, lower, removeSpace);

		return finalText.includes(finalSearch);
	};

	if (typeof text !== 'object')
		return checkSearch(text);

	let find = false;
	text.forEach(actualText => find = find || checkSearch(actualText));

	return find;
}